<div class="user-name-container">
	<button mat-button [matMenuTriggerFor]="menu" class="flex center gap-8 pointer bg-inherit" [ngClass]="{'no-hover': hoverDisabled}">
		<ngx-emoji [sheetSize]="32"
			emoji="flag-{{ countryFlagOverride?.[getLanguageService.currentLanguage] ? countryFlagOverride[getLanguageService.currentLanguage] : getLanguageService.currentLanguage }}"
			set="facebook" class="size-icon flag-icon-header" [size]="20">
		</ngx-emoji>
		<span class="text-lang" [ngClass]="{'text-accent-lighter': textColorWhite}">
			@if(showAbbreviation){
				{{getLanguageService.currentLanguage | uppercase}}
			}@else {
				{{'language-translations.'+getLanguageService.currentLanguage | translateWithKeys}}
				<mat-icon class="icon-drop" svgIcon="drop_icon"></mat-icon>
			}
		</span>
	</button>
</div>
<mat-menu name="language" ngDefaultControl #menu="matMenu" [(ngModel)]="getLanguageService.currentLanguage">
	<div class="flex column gap-8 start select-language">
		@for(language of availableLanguages; track $index){
			<button mat-menu-item (click)="changeLanguage(language)" class="body2 text-accent-darker">
				<ngx-emoji [sheetSize]="32" emoji="flag-{{ countryFlagOverride?.[language] ? countryFlagOverride[language] : language }}" set="facebook" class="flag-icon-position" [size]="20"></ngx-emoji>
				{{ ('language-translations.' + language) | translate }}
			</button>
		}
	</div>
</mat-menu>
